import React from 'react';
import './DirectoryBadges.css';

/**
 * Professional directory trust badges — hidden by default, flip the `verified`
 * flag on each entry once the listing goes live. Each entry renders a small
 * plum+gold pill linking out to the directory profile.
 *
 * Why this format: directories often take 2–6 weeks to verify credentials
 * and approve new listings. We don't want a "coming soon" stub to go live on
 * the marketing site. Each badge activates independently when its URL is set.
 */
const DIRECTORIES = [
  {
    key: 'apha',
    label: 'APHA Member',
    fullName: 'Alliance of Professional Health Advocates',
    url: '', // paste your APHA listing URL here once approved
  },
  {
    key: 'advoconnection',
    label: 'AdvoConnection',
    fullName: 'AdvoConnection Directory',
    url: '', // paste your AdvoConnection listing URL here once approved
  },
  {
    key: 'gna',
    label: 'Greater National Advocates',
    fullName: 'Greater National Advocates',
    url: '', // paste your GNA listing URL here once approved
  },
  {
    key: 'bcpa',
    label: 'BCPA Certified',
    fullName: 'Board Certified Patient Advocate (PACB)',
    url: '', // if/when a founder earns BCPA
  },
];

const DirectoryBadges = () => {
  const active = DIRECTORIES.filter((d) => d.url);
  if (active.length === 0) return null; // nothing approved yet — render nothing

  return (
    <section
      className="directory-badges"
      aria-labelledby="directory-badges-heading"
      data-testid="directory-badges"
    >
      <h4 id="directory-badges-heading" className="directory-badges-title">
        Listed in Professional Advocate Directories
      </h4>
      <ul className="directory-badges-list">
        {active.map((d) => (
          <li key={d.key}>
            <a
              href={d.url}
              target="_blank"
              rel="noopener noreferrer"
              className="directory-badge"
              title={`View our ${d.fullName} listing`}
              data-testid={`directory-badge-${d.key}`}
            >
              <span className="directory-badge-check" aria-hidden="true">✓</span>
              <span className="directory-badge-label">{d.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default DirectoryBadges;
